import { render, staticRenderFns } from "./ProductCreation.vue?vue&type=template&id=930d5e9a&"
import script from "./ProductCreation.vue?vue&type=script&lang=js&"
export * from "./ProductCreation.vue?vue&type=script&lang=js&"
import style0 from "./ProductCreation.vue?vue&type=style&index=0&id=930d5e9a&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/piscinaFacilDev/piscinapp-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('930d5e9a')) {
      api.createRecord('930d5e9a', component.options)
    } else {
      api.reload('930d5e9a', component.options)
    }
    module.hot.accept("./ProductCreation.vue?vue&type=template&id=930d5e9a&", function () {
      api.rerender('930d5e9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/ProductCreation.vue"
export default component.exports